import { render, staticRenderFns } from "./hotelLinkConfig.vue?vue&type=template&id=12f0e9fe"
import script from "./hotelLinkConfig.vue?vue&type=script&lang=js"
export * from "./hotelLinkConfig.vue?vue&type=script&lang=js"
import style0 from "./hotelLinkConfig.vue?vue&type=style&index=0&id=12f0e9fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports